import React, { useState } from 'react';
const faqs = [{
  q: 'Ist das System für Anfänger geeignet?',
  a: 'Absolut. Das System ist so konzipiert, dass es funktioniert, egal ob Sie 1 Jahr oder 20 Jahre Erfahrung haben. Jede Einheit ist vollständig strukturiert mit klaren Zielen, Aufwärmübungen, Aktivitäten und Cool-downs. Sie folgen einfach dem Plan.'
}, {
  q: 'Welche Altersgruppen deckt das Material ab?',
  a: 'BASKETBALL BEREIT 360 deckt alle Altersgruppen vom Anfänger bis zum fortgeschrittenen Vereinsspieler ab. Jeder Band enthält Anpassungen für verschiedene Alters- und Leistungsstufen.'
}, {
  q: 'Ist dies ein physisches oder digitales Produkt?',
  a: 'Dies ist ein 100% digitales Produkt. Sie erhalten alles sofort nach dem Kauf als hochwertige PDF-Dateien. Kein Versand, keine Wartezeit, keine Apps erforderlich.'
}, {
  q: 'Wie erhalte ich meinen Kauf?',
  a: 'Unmittelbar nach der Zahlung erhalten Sie einen Download-Link per E-Mail. Ein Klick und das gesamte Paket ist auf Ihrem Gerät. Funktioniert auf Handy, Tablet, Laptop oder zum Ausdrucken.'
}, {
  q: 'Was ist, wenn ich nicht zufrieden bin?',
  a: 'Sie sind durch unsere 7-Tage Geld-zurück-Garantie vollständig abgesichert. Keine Fragen, keine Formulare, kein Stress. Senden Sie uns einfach eine E-Mail und wir erstatten Ihnen den vollen Betrag.'
}, {
  q: 'Kann ich das für den Schulsport verwenden?',
  a: 'Ja. BASKETBALL BEREIT 360 wurde speziell für Sportlehrer an Schulen und Vereinstrainer entwickelt. Jeder Stundenentwurf und jedes Bewertungstool ist auf das schulische Umfeld abgestimmt.'
}, {
  q: 'Wie unterscheidet sich das von kostenlosen Ressourcen im Internet?',
  a: 'Kostenlose Ressourcen sind verstreut, inkonsistent und nicht mit einem Progressionssystem verbunden. BASKETBALL BEREIT 360 ist ein komplettes Curriculum, das auf einer logischen Jahresprogression aufbaut. Es spart Ihnen hunderte von Stunden pro Jahr.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white py-16 px-4" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] text-center mb-10 tracking-tight" data-id="element-37">
          Häufig gestellte <span className="text-[#FF6B00]" data-id="element-38">Fragen</span>
        </h2>

        <div className="bg-white border border-[#E5E5EA] rounded-2xl divide-y divide-[#E5E5EA] overflow-hidden shadow-sm" data-id="element-39">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-[#FAFAFA] hover:bg-white transition-colors" data-id="element-40">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-41">
                  <span className="text-[#0A0A0A] font-black text-base" data-id="element-42">
                    {faq.q}
                  </span>
                  <span className={`text-[#FF6B00] text-xl font-black flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-43">
                    +
                  </span>
                </button>
                {isOpen && <div className="px-6 pb-5 -mt-2" data-id="element-44">
                    <p className="text-[#5A5A66] text-sm sm:text-base font-medium leading-relaxed" data-id="element-45">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}